<template>
  <div :class="{'out-of-view': !isVisible}" class="upload-box elevation-12">
    <v-toolbar
      dark
      color="primary"
    >
      <span v-text="boxTitle"></span>
      <v-spacer></v-spacer>
      <v-btn icon @click="close" :disabled="fileUploadInProgress">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card>
      <input ref="fileInput" type="file" name="file" class="d-none" multiple>
      <div ref="fileList" class="v-list file-list"></div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import jQuery from 'jquery';
import 'blueimp-load-image';
import 'blueimp-file-upload';
import 'blueimp-file-upload/js/vendor/jquery.ui.widget';
import 'blueimp-file-upload/js/jquery.fileupload-ui';
import { getFilenameExtension, getMimeTypeData, getPlural } from '../../helpers/helpers';
import config from './../../config';

export default {
  name: 'files-upload',
  data() {
    return {
      boxTitle: '',
      isVisible: false,
    };
  },
  computed: {
    ...mapGetters('files', [
      'fileUploadInProgress',
    ]),
  },
  mounted() {
    this.initFileUploader();

    this.$eventBus.$on('Files/FilesUpload/selectFiles', ({ files }) => {
      jQuery(this.$refs.fileInput).fileupload('add', { files });
      this.isVisible = true;
      this.setFileUploadActivity(true);
    });
    this.$eventBus.$on('Files/FilesUpload/hide', () => {
      if (!this.fileUploadInProgress) {
        this.close();
      }
    });
  },
  destroyed() {
    jQuery(this.$refs.fileInput).fileupload('destroy');
  },
  methods: {
    ...mapActions('files', [
      'setFileUploadActivity',
    ]),
    close() {
      this.isVisible = false;
      jQuery(this.$refs.fileList).empty();
    },
    initFileUploader() {
      const vm = this;
      // TODO - te dwie stale powinny być pobierane np. ze store
      const appLang = 'pl';
      const version = '1.0';
      jQuery(this.$refs.fileInput).fileupload({
        url: `${config.apiUrl}/api/${version}/${appLang}/app/fs/files/store`,
        maxChunkSize: config.fileUpload.maxChunkSize || 5000000, // 5mb
        maxNumberOfFiles: config.fileUpload.maxNumberOfFiles || 100,
        method: 'POST',
        sequentialUploads: true,
        prependFiles: true,
        dataType: 'json',
        autoUpload: true,
        acceptFileTypes: config.fileUpload.acceptFileTypes || /(\.|\/)(aac|abw|arc|avi|azw|bin|bmp|bz|bz2|csh|css|csv|doc|docx|eot|epub|es|gif|htm|html|ico|ics|jar|jpeg|jpg|json|mid|midi|mpeg|mpkg|odp|ods|odt|oga|ogv|ogx|otf|png|pdf|ppt|pptx|rar|rtf|svg|swf|tar|tif|tiff|ttf|txt|vsd|wav|weba|webm|webp|woff|woff2|xhtml|xlsxlsx|xml|xul|zip|dscan|mscan|tscan|hcmd|sproj|hist)$/i,
        maxFileSize: config.fileUpload.maxFileSize || 100000000, // 100mb
        dropZone: false,
        formData() {
          return [
            { name: 'parent_item_id', value: vm.$route.params.id },
          ];
        },
        messages: {
          maxNumberOfFiles: 'Przekroczono dozwoloną liczbę plików',
          acceptFileTypes: 'Niedozwolony typ pliku',
          maxFileSize: 'Plik jest zbyt duży',
          minFileSize: 'Plik jest zbyt mały',
          unknownError: 'Wystąpił nieznany błąd',
        },
        filesContainer: jQuery(this.$refs.fileList),
        uploadTemplateId: null,
        downloadTemplateId: null,
        uploadTemplate(o) {
          let rows = jQuery();
          jQuery.each(o.files, (index, file) => {
            const row = jQuery(`${''}
            <div class="template-upload v-list__tile v-list__tile--avatar">
              <div class="v-list__tile__action jsIcon"></div>
              <div class="v-list__tile__content">
                <div class="v-list__tile__title jsName"></div>
                <div title="" class="v-list__tile__sub-title error--text jsError"></div>
              </div>
              <div class="v-list__tile__action">
                <i aria-hidden="true" class="jsErrorIcon d-none v-icon error--text material-icons">error</i>
                <div class="jsProgress v-progress-circular v-progress-circular--indeterminate primary--text" style="height: 24px; width: 24px;">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="22.857142857142858 22.857142857142858 45.714285714285715 45.714285714285715" style="transform: rotate(0deg);"><circle fill="transparent" cx="45.714285714285715" cy="45.714285714285715" r="20" stroke-width="5.714285714285714" stroke-dasharray="125.664" stroke-dashoffset="25.132741228718345px" class="v-progress-circular__overlay"></circle></svg>
                  <div class="v-progress-circular__info"></div>
                </div>
                <button type="button" class="cancel v-btn v-btn--icon ml-1">
                  <div class="v-btn__content">
                    <i aria-hidden="true" class="v-icon error--text material-icons">cancel</i>
                  </div>
                </button>
              </div>
            </div>`);
            row.find('.jsName').text(file.name);
            const fileExt = getFilenameExtension(file.name);
            const iconData = getMimeTypeData(fileExt, true);
            const icon = `<i aria-hidden="true" class="v-icon ${iconData.icon} ${iconData.color}"></i>`;
            row.find('.jsIcon').html(icon);
            rows = rows.add(row);
          });
          return rows;
        },
        downloadTemplate(o) {
          let rows = jQuery();
          jQuery.each(o.files, (index, file) => {
            const row = jQuery(`${''}
            <div class="template-download v-list__tile v-list__tile--avatar">
              <div class="v-list__tile__action jsIcon"></div>
              <div class="v-list__tile__content">
                <div class="v-list__tile__title jsName"></div>
                <div class="v-list__tile__sub-title error--text jsError"></div>
              </div>
              <div class="v-list__tile__action">
                <i aria-hidden="true" class="jsSuccessIcon d-none v-icon success--text material-icons">check_circle</i>
                <i aria-hidden="true" class="jsErrorIcon d-none v-icon error--text material-icons">error</i>
              </div>
            </div>`);
            const fileExt = getFilenameExtension(file.name);
            const iconData = getMimeTypeData(fileExt, true);
            const icon = `<i aria-hidden="true" class="v-icon ${iconData.icon} ${iconData.color}"></i>`;
            row.find('.jsIcon').html(icon);
            row.find('.jsName').text(file.name);
            if (file.error) {
              row.find('.jsErrorIcon').removeClass('d-none');
              row.find('.jsError').text(file.error);
            } else {
              row.find('.jsSuccessIcon').removeClass('d-none');
            }
            rows = rows.add(row);
          });
          return rows;
        },
        progressall(e, data) {
          const progress = parseInt((data.loaded / data.total) * 100, 10);
          if (progress === 100) {
            vm.setFileUploadActivity(false);
            setTimeout(() => {
              vm.$emit('upload-finished');
            }, 1000);
          }
        },
      })
        .on('fileuploadsend', (e, data) => {
          data.headers = {
            Authorization: `Bearer ${this.$store.state.app.token}`,
          };
        })
        // obsluga bledu wysylania pliku - tutaj mamy dostep do odpowiedzi serwera
        .on('fileuploadfailed', (e, data) => {
          // data.jqXHR.responseJSON - tresc odpowiedzi
          // data.jqXHR.status - status odpowiedzi
          // TODO obsluzyc do konca bledy serwera
          let msg = vm._.get(data, 'jqXHR.responseJSON.status.msg', false);
          const code = vm._.get(data, 'jqXHR.responseJSON.status.code', false);
          const leftSpaceError = vm._.get(data, 'jqXHR.responseJSON.data.left_space[0]', false);
          if (code === -10 && leftSpaceError) {
            msg = leftSpaceError;
          }
          if (msg) {
            data.context.find('.jsError').html(msg).prop('title', msg);
          }
        })
        // obsluga zdarzenia bledu przed wyslaniem pliku, np. zly typ pliku lub rozmiar
        .on('fileuploadprocessfail', (e, data) => {
          if (typeof data.files !== 'undefined' && typeof data.files[0] !== 'undefined' && data.files[0].error) {
            data.context.find('.jsError').html(data.files[0].error);
            data.context.find('.jsProgress').addClass('d-none');
            data.context.find('.jsErrorIcon').removeClass('d-none');
          }
        })
        .on('fileuploadadded', (e, data) => {
          vm.setFileUploadActivity(true);
          const filesCount = jQuery(data.context).closest('.v-list').children().length;
          vm.boxTitle = getPlural(filesCount, ['Przesyłanie %d pliku', 'Przesyłanie %d plików', 'Przesyłanie %d plików']);
        })
        .on('fileuploadalways', (e, data) => {
          const filesCount = jQuery(data.context).closest('.v-list').children().length;
          vm.boxTitle = getPlural(filesCount, ['Przesyłanie %d pliku', 'Przesyłanie %d plików', 'Przesyłanie %d plików']);
        })
        // formowanie odpowiedzi serwera na postac jaka przyjmuje wtyczka jquery file upload
        // https://github.com/blueimp/jQuery-File-Upload/wiki/Setup#using-jquery-file-upload-ui-version-with-a-custom-server-side-upload-handler
        .on('fileuploaddone', (e, data) => {
          const file = {
            deleteType: 'DELETE',
            deleteUrl: '#',
            type: data.files[0].type,
            thumbnailUrl: '#',
            url: '#',
            name: data.files[0].name,
            size: data.files[0].size,
          };
          data.result.files = [file];
        })
        .on('fileuploadprocessstop', () => {
          vm.setFileUploadActivity(false);
        })
        .on('fileuploadstopped', () => {
          vm.setFileUploadActivity(false);
        });
    },
  },
};
</script>

<style scoped>
  .upload-box {
    width: 400px;
    max-width: calc(100% - 48px);
    position: fixed;
    bottom: 24px;
    right: 24px;
    z-index: 150;
  }
  .file-list{
    max-height: 264px;
    overflow-y: scroll;
  }
</style>
